import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
// LOCAL
import ManageEmailSubscriptionsContainer from './ManageEmailSubscriptionsContainer'

class ManageEmailSubscriptionsPage extends React.Component {

  render() {
    return (
      <ManageEmailSubscriptionsContainer location={this.props.location} params={this.props.match.params} />
    );
  }
}

export default connect()(ManageEmailSubscriptionsPage)



// WEBPACK FOOTER //
// ./src/subscriptions/ManageEmailSubscriptionsPage.js